// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2qe8r","rootMobile":"styles_rootMobile__39tzc"};